import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import CognitoContextProvider from './components/CognitoContextProvider/CognitoContextProvider';
import { store } from './redux/store';
import './auth/Amplify';

import './styles/_globals.scss';
import './styles/_icons.scss';
import 'typeface-roboto';

const rootElement = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(rootElement!);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <CognitoContextProvider>
        <App />
      </CognitoContextProvider>
    </BrowserRouter>
  </Provider>,
);
